import { createFileRoute, useRouter } from "@tanstack/react-router";
import { z } from "zod";

import { AppointmentTypeTextFieldForm } from "@/components/appointment/type/appointment-type-text-field-form";

import type { JSX } from "react";

const AppointmentTypePatientInformationPage = (): JSX.Element => {
  const router = useRouter();
  const params = Route.useParams();

  return (
    <AppointmentTypeTextFieldForm
      appointmentTypeId={params.appointmentTypeId}
      field="patientInformation"
      onSaved={() => router.history.back()}
    />
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/$appointmentTypeId/patient-info",
)({
  parseParams: (params) => ({
    appointmentTypeId: z.int().parse(Number(params.appointmentTypeId)),
  }),
  component: AppointmentTypePatientInformationPage,
});
